import { h } from "preact";

import { classNames } from "../helpers";

export default function BigDot({ color, small, ...props }) {
  const classes = classNames(
    props.class,
    "big-dot",
    `big-dot--${color}`,
    small && "big-dot--small"
  );

  return <span {...props} class={classes}></span>;
}
